import { message } from "antd";
import React, { useEffect, useState } from "react";

import {
  getCommission,
  getCondition,
  getPackage,
} from "../controller/api_home_care";
import Introduce from "./page/1-introduce";
import Package from "./page/2-package";
import InsuInfomation from "./page/3-insuinfomation";
import CreateOrder from "./page/4-createOrder";
import { getParamUrlByKey } from "./utils";

import "antd/dist/antd.css";
import "antd-mobile/bundle/style.css";
import "./styles/style.css";

export const AuthContext = React.createContext();

const Tomato = () => {
  const [step, setStep] = useState(1);
  const [dataIsu, setDataIsu] = useState({});
  const [ArrPackage, setArrPackage] = useState([]);
  const [bonus, setBonus] = useState(0);
  const [subsidyAmount, setSubsidyAmount] = useState(0);
  const [dataCondition, setDataCondition] = useState({});
  const [dataCheckReDeem, setDataCheckReDeem] = useState(null);
  const [loadingBonus, setLoadingBonus] = useState(false);

  const goStep = (page) => {
    setStep(page);
  };

  const PageView = () => {
    switch (step) {
      case 1:
        return <Introduce />;
      case 2:
        return <Package />;
      case 3:
        return <InsuInfomation />;
      case 4:
        return <CreateOrder />;
    }
  };

  const SetDataIsu = async (values) => {
    setDataIsu({
      ...dataIsu,
      ...values,
    });
  };

  const getPackageList = async () => {
    const res = await getPackage();
    if (res?.statusCode === 200) {
      setArrPackage(res.result?.packages);
    } else {
      message.error(res?.message || "Lấy danh sách gói bảo hiểm thất bại.", 2);
    }
  };

  const getBonus = async () => {
    setLoadingBonus(true);
    let dataIsu = JSON.parse(localStorage.getItem("dataIsuTomato"));
    let data = {
      packageId: dataIsu?.package,
      reward: getParamUrlByKey("reward") === "true" ? 1 : undefined,
    };

    const res = await getCommission(data);
    if (res?.statusCode === 200) {
      setBonus(res?.result?.commission);
      setSubsidyAmount(res?.result?.subsidyAmount);
    } else {
      message.error(res?.message || "Lấy hoa hồng thất bại!", 2);
    }
    setLoadingBonus(false);
  };

  const getConditionRedeem = async () => {
    let data = {
      productId: 28,
    };

    const res = await getCondition(data);
    if (res?.statusCode === 200) {
      setDataCondition(res?.result);
    } else {
      message.error(res?.message || "Lỗi kiểm tra mã giảm giá!", 2);
    }
  };

  useEffect(() => {
    if (dataIsu?.package) {
      localStorage.setItem(
        "dataIsuTomato",
        JSON.stringify({
          ...dataIsu,
        })
      );
    }
  }, [dataIsu]);

  useEffect(() => {
    let dataIsu = JSON.parse(localStorage.getItem("dataIsuTomato"));
    if (dataIsu) {
      setDataIsu(dataIsu);
    }
    getPackageList();
    getConditionRedeem();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        goStep,
        step,
        ArrPackage,
        SetDataIsu,
        dataIsu,
        bonus,
        getBonus,
        subsidyAmount,
        dataCondition,
        dataCheckReDeem,
        setDataCheckReDeem,
        loadingBonus,
      }}
    >
      <div style={{ maxWidth: 800, margin: "0px auto" }}>{PageView()}</div>
    </AuthContext.Provider>
  );
};

export default Tomato;
